<section class="join-us mt-55">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="sata-title-black">{{'SATACONTACT' }}</h2>
            </div>

            <div class="col-md-12">
                <!-- start form -->
                <form [formGroup]="form" class="mt-25">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="name">
                                        {{'NAME'}}
                                        <span class="required" *ngIf="form.get('name').hasError('required')">*</span>
                                    </label>
                                    <input type="text" class="form-control" id="name" formControlName="name">                            
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="branches">
                                        {{'BRAND' }}
                                        <span class="required" *ngIf="form.get('brand_name').hasError('required')">*</span>
                                    </label>
                                    <input type="text" class="form-control" id="brand_name" formControlName="brand_name">                            
                                </div>
                            </div> 

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="area_id">
                                        {{'AREA' }}
                                        <span class="required" *ngIf="form.get('area_id').hasError('required')">*</span>
                                    </label>
                                    <select class="form-control" id="area_id" formControlName="area_id">
                                        <option *ngFor="let city of cities" [value]="city.id">{{city.name}}</option>
                                    </select>                           
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="category_id">
                                        {{'CATEGORY' }}
                                        <span class="required" *ngIf="form.get('category_id').hasError('required')">*</span>
                                    </label>
                                    <select class="form-control" id="category_id" formControlName="category_id">
                                        <option *ngFor="let cat of categories" [value]="cat.id">{{cat.name}}</option>
                                    </select>                           
                                </div>
                            </div> 
                            
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="branches">
                                        {{'BRANCHES' }}
                                        <span class="required" *ngIf="form.get('branches').hasError('required')">*</span>
                                    </label>
                                    <input type="text" numbersOnly class="form-control" id="branches" formControlName="branches">                            
                                </div>
                            </div>   

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone">
                                        {{'PHONE' }}
                                        <span class="required" *ngIf="form.get('phone').hasError('required')">*</span>
                                    </label>
                                    <input type="text" numbersOnly class="form-control" id="phone" formControlName="phone" maxlength="11">                            
                                </div>

                                <p class="invalid-feedback" *ngIf="form.get('phone').hasError('minlength')">
                                    {{'PHONEVALIDATION1' }}
                                </p>                                   
                                <p class="invalid-feedback" *ngIf="form.get('phone').hasError('notStartWith0')">                                    
                                    {{'PHONEVALIDATION2' }}
                                </p>                                   
                            </div>     

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone">
                                      {{'EMAIL' }}
                                    </label>
                                    <input type="email" class="form-control" id="email" formControlName="email">                            
                                </div>

                                <p class="invalid-feedback" *ngIf="form.get('email').hasError('pattern')">
                                    {{'EMAILVALIDATION' }}
                                </p>                               
                            </div>  

                        

                        
                            
                            <div class="col-md-12 text-left">
                                <button class="submit-btn btn"  (click)="addRequest()">
                                   ارسال
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- end form -->
            </div>
        </div>
    </div>
</section>
